import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useMemo,
  useState
} from "react";

export interface IInviteFormContext {
  contextDisplayName: string;
  setContextDisplayName: Dispatch<SetStateAction<string>>;

  // MAYBE redundant
  contextEmailAddress: string;
  setContextEmailAddress: Dispatch<SetStateAction<string>>;

  contextDisableSubmit: boolean;
  setContextDisableSubmit: Dispatch<SetStateAction<boolean>>;

  contextReInviteMode: boolean;
  setContextReInviteMode: Dispatch<SetStateAction<boolean>>;
}

export const defaultInviteFormContextValue = {
  contextDisplayName: "",
  setContextDisplayName: () => {},

  // MAYBE redundant
  contextEmailAddress: "",
  setContextEmailAddress: () => {},

  contextDisableSubmit: false,
  setContextDisableSubmit: () => {},

  contextReInviteMode: false,
  setContextReInviteMode: () => {}
};

export const InviteFormContext = createContext<IInviteFormContext>(
  defaultInviteFormContextValue
);

export const InviteFormContextProvider = ({ children }) => {
  const [displayName, setDisplayName] = useState("");
  const [emailAddress, setEmailAddress] = useState(""); // MAYBE redundant
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reInviteMode, setReInviteMode] = useState(false);

  const value = useMemo(() => {
    return {
      contextDisplayName: displayName,
      setContextDisplayName: setDisplayName,

      // MAYBE redundant
      contextEmailAddress: emailAddress,
      setContextEmailAddress: setEmailAddress,

      contextDisableSubmit: disableSubmit,
      setContextDisableSubmit: setDisableSubmit,

      contextReInviteMode: reInviteMode,
      setContextReInviteMode: setReInviteMode
    };
  }, [displayName, emailAddress, reInviteMode, disableSubmit]);

  return (
    <InviteFormContext.Provider value={value}>
      {children}
    </InviteFormContext.Provider>
  );
};

export const useInviteFormContext = () => useContext(InviteFormContext);
